/**
 * Saga "Krachtig en compact" — dot navigation for the mobile scroll-snap
 * track. No carousel library and no scrollIntoView (which can also scroll
 * ancestor containers on a long page): a plain track.scrollTo with an
 * explicit left offset, and an IntersectionObserver (the same technique
 * already used for the arrow show/hide logic on the authority-panel
 * section) to keep the active dot in sync with whatever the visitor
 * actually scrolled to, by touch or keyboard.
 */
document.addEventListener('DOMContentLoaded', function () {
  if (window.sagaKcInit) return;
  window.sagaKcInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-saga-kc-track]').forEach(function (track) {
    var root = track.closest('.saga-kc');
    if (!root) return;

    var cards = Array.from(track.querySelectorAll('[data-saga-kc-card]'));
    var dotsWrap = root.querySelector('[data-saga-kc-dots]');
    var dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('[data-saga-kc-dot]')) : [];

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('saga-kc__dot--active', i === index);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var card = cards[i];
        if (!card) return;
        var trackRect = track.getBoundingClientRect();
        var cardRect = card.getBoundingClientRect();
        var targetLeft = track.scrollLeft + (cardRect.left - trackRect.left);
        track.scrollTo({ left: targetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });

    if (!('IntersectionObserver' in window) || dots.length === 0) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = cards.indexOf(entry.target);
          if (index > -1) setActive(index);
        });
      },
      { root: track, threshold: 0.6 }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  });
});
